export default "__VITE_ASSET__BOL6fvWE__"